import { render, staticRenderFns } from "./vsRow.vue?vue&type=template&id=512757c0&lang=html&"
import script from "./vsRow.vue?vue&type=script&lang=js&"
export * from "./vsRow.vue?vue&type=script&lang=js&"
import style0 from "./vsRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsRow.vue"
export default component.exports